'use client';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import BreadCrumbs from '../share/BreadCrumb';
import React, { useRef, useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function CategoryHeader({ object, type }) {
  const subcategoriesListRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(true);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const searchParams = useSearchParams();
  const isMobile = useIsMobile();

  useEffect(() => {
    const subcategoriesList = subcategoriesListRef.current;

    const handleScroll = () => {
      setShowRightArrow(subcategoriesList.scrollLeft < 0);
      setShowLeftArrow(
        subcategoriesList.scrollLeft <
          subcategoriesList.scrollWidth - subcategoriesList.clientWidth
      );
    };

    if (subcategoriesList) {
      subcategoriesList.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    return () => {
      if (subcategoriesList) {
        subcategoriesList.removeEventListener('scroll', handleScroll);
      }
    };
  }, [subcategoriesListRef.current]);

  const handleLeftArrowClick = () => {
    const subcategoriesList = subcategoriesListRef.current;
    subcategoriesList.scrollTo({
      left: subcategoriesList.scrollLeft - 200,
      behavior: 'smooth',
    });
  };

  const handleRightArrowClick = () => {
    const subcategoriesList = subcategoriesListRef.current;
    subcategoriesList.scrollTo({
      left: subcategoriesList.scrollLeft + 200,
      behavior: 'smooth',
    });
  };

  return (
    <div className="category-header">
      <BreadCrumbs
        breadcrumb={
          type === 'brandCategory'
            ? [
                ...(object.breadcrumb ?? []),
                { link: 'brand/', title: 'برندها' },
              ]
            : object.breadcrumb
        }
        objectTitle={object.title}
        objectLink={object?.url}
        type={type === 'brandCategory' ? 'brandCategory' : 'cat'}
      />
      <div className=" cat-title flex items-center w-full md:w-auto  pl-10 text-base font-bold ">
        <h1>
          {object.title}
          {searchParams.get('page') &&
            searchParams.get('page') != 1 &&
            `- صفحه ${searchParams.get('page')}`}
        </h1>
      </div>
      {object.meta?.banner && (
        <div className="mt-4 category-top-header">
          <Link href={object?.meta?.banner?.link || '#'} target="_blank">
            {!isMobile
              ? object?.meta?.banner?.desktop?.path !== '' && (
                  <Image
                    src={object?.meta?.banner?.desktop?.path}
                    width={1280}
                    height={154}
                    alt={object.meta?.banner?.desktop?.alt}
                    style={{ borderRadius: '10px' }}
                    loading="eager"
                    fetchPriority={'low'}
                  />
                )
              : object?.meta?.banner?.mobile?.path !== '' && (
                  <Image
                    src={object.meta?.banner?.mobile?.path}
                    width={587}
                    height={154}
                    alt={object.meta?.banner?.mobile?.alt}
                    style={{ borderRadius: '10px' }}
                    loading="eager"
                    fetchPriority={'low'}
                  />
                )}
          </Link>
        </div>
      )}

      {object.sub_categories && object.sub_categories.length > 0 && (
        <>
          <div className="relative">
            <div
              className="subCategories mt-4 flex md:items-center items-start overflow-x-scroll flex-nowrap "
              ref={subcategoriesListRef}
            >
              {object.sub_categories.map((subCat, i) => (
                <Link
                  className="md:border border-light-gray-300 md:flex items-center rounded-md ml-4 md:py-4 md:px-4 px-0 "
                  href={`/cat${subCat.url}`}
                  key={i}
                >
                  <div className="w-[85px] flex border rounded-md  border-light-gray-300 md:border-none p-1 md:p-0 ">
                    <Image
                      src={
                        subCat?.product_thumb?.full_path ||
                        '/images/no-image.jpg'
                      }
                      width={85}
                      height={85}
                      alt={subCat?.product_thumb?.alt}
                      loading="eager"
                      fetchPriority={'low'}
                    />
                  </div>
                  <div className="text-xs text-center md:font-bold md:pr-4 pt-2 md:pt-0  md:whitespace-nowrap">
                    {subCat.title}
                  </div>
                </Link>
              ))}
            </div>
            <div className="">
              <button
                id="cat_arrow_left"
                onClick={handleLeftArrowClick}
                className="absolute md:top-12 top-7 left-0 bg-white shadow-[0_0_14px_0_#00000014] p-2 rounded-md"
                style={{ display: showLeftArrow ? 'block' : 'none' }}
              >
                <CaretLeft />
              </button>
              <button
                id="cat_arrow_right"
                onClick={handleRightArrowClick}
                className="absolute md:top-12  top-7 right-0 bg-white shadow-[0_0_14px_0_#00000014] p-2 rounded-md"
                style={{ display: showRightArrow ? 'block' : 'none' }}
              >
                <CaretLeft className="rotate-180" />
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
